const isValid = (containers) => {
  if (containers.length == 0) {
    return false;
  }
  return true;
};

export default {
  isValid
};